<template>
  <div style="width: 100%; height: 100%;" v-bind:style="{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover' }">
    <LoginPage v-if="!state.isAuthenticated"/>
    <MainPage v-if="state.isAuthenticated"/>
  </div>
</template>

<script setup lang="ts">
import LoginPage from './components/LoginPage.vue'
import MainPage from './components/MainPage.vue'

import backgroundImage from '@/components/icons/automation-portal-background.webp';
import { state } from "@/services/msal-config";

</script>


<style scoped></style>
